import { render, staticRenderFns } from "./cabinOfPossibilityMobile.vue?vue&type=template&id=2dec4fea&scoped=true&"
import script from "./cabinOfPossibilityMobile.vue?vue&type=script&lang=js&"
export * from "./cabinOfPossibilityMobile.vue?vue&type=script&lang=js&"
import style0 from "./cabinOfPossibilityMobile.vue?vue&type=style&index=0&id=2dec4fea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec4fea",
  null
  
)

export default component.exports